module.exports = __webpack_public_path__ + "static/media/fuel_trim.2538e1d5.svg";